import React from 'react'
import s from './TopItineraries.less'
import { localeCountryIsFrance } from '../../i18n'
import { useSelector } from 'react-redux'
import { selectLocale } from '../../../store/navigation/navigation.selectors'
import { selectSeoItineraryData } from '../../../store/seo/seo.selectors'
import { selectSeoCurrentMode } from '../../../store/itinerary/itinerary.selectors'
import { withEmptyFallbackErrorBoundary } from '../../error/EmptyFallbackErrorBoundary'
import { translate } from '../../i18n/T'
import { MULTIPATH_MODE_CAR } from '../../../store/itinerary/itinerary.constants'

const TopItineraries = () => {
  const locale = useSelector(selectLocale)
  const seoCurrentMode = useSelector(selectSeoCurrentMode)
  const isNotCar = seoCurrentMode && seoCurrentMode !== MULTIPATH_MODE_CAR
  const modeLabel = isNotCar ? translate(locale)(`itinerary.modes.${seoCurrentMode}`) : ''
  const { links, mappingTitle } = useSelector(selectSeoItineraryData)

  if (!localeCountryIsFrance(locale) || !mappingTitle) return <></>

  if (!links || links.length === 0) return

  return (
    <>
      <h2 className={s.textSeoMappingTitle}>{mappingTitle}</h2>
      <ul>
        {links.map((item, idx) => (
          <li key={idx} className={s.itineraryItem}>
            <a
              className={s.itineraryItemLink}
              href={item.url}
            >{`Itinéraire ${modeLabel} ${item.fromName} - ${item.toName}`}</a>
          </li>
        ))}
      </ul>
    </>
  )
}

export default withEmptyFallbackErrorBoundary(TopItineraries)
